import { Spinner as FluentSpinner } from "@fluentui/web-components";
/**
 * Spinner
 * @summary A Fabric UI Spinner component that provides a visual indication of loading state with customizable size and appearance.
 *
 * @example
 * ```html
 * <fabric-spinner size="large" appearance="primary"></fabric-spinner>
 * ```
 *
 * @attr {SpinnerSize} size - The size of the spinner. One of 'tiny', 'extra-small', 'small', 'medium', 'large', 'extra-large', 'huge'.
 * @attr {SpinnerAppearance} appearance - The appearance of the spinner. One of 'primary', 'inverted'.
 *
 * @prop {SpinnerSize} size - The size of the spinner. One of 'tiny', 'extra-small', 'small', 'medium', 'large', 'extra-large', 'huge'.
 * @prop {SpinnerAppearance} appearance - The appearance of the spinner. One of 'primary', 'inverted'.
 *
 * @slot indicator - Custom content that replaces the default spinner indicator.
 *
 * @csspart background - The background layer of the spinner.
 * @csspart progress - The container for the spinner progress animation.
 * @csspart spinner - The spinner animation container.
 * @csspart start - The start section of the spinner animation.
 * @csspart end - The end section of the spinner animation.
 * @csspart indicator - The visual element that indicates the loading process.
 *
 * @cssprop --duration - Controls the animation duration for the spinner.
 * @cssprop --indicatorSize - Sets the rendered size of the spinner indicator.
 * @cssprop --size - Sets the overall size used by the spinner component.
 *
 * @extends FluentSpinner
 * @tagname fabric-spinner
 * @public
 */
export class Spinner extends FluentSpinner {
}
//# sourceMappingURL=spinner.js.map